import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { withRouter } from "react-router";
import moment from "moment";

import { useStyles } from "../CustomerMyBooks.css";

class MyBooksBody extends Component {
  render() {
    const { classes, index, book } = this.props;
    return (
      <TableRow
        className={classes.tablerow}
        onClick={() => this.props.history.push(`/books/details/${book._id}`)}
      >
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">
          <img
            src={book.bookCoverUrl}
            alt={book.title}
            style={{ width: 50, height: 50 }}
          />
        </TableCell>
        <TableCell align="center">{book.title}</TableCell>
        <TableCell align="center">
          {book.author.firstName} {book.author.middleName}{" "}
          {book.author.lastName}
        </TableCell>
        <TableCell align="center">{book.genre}</TableCell>
        <TableCell align="center">
          {moment(new Date(book.publishedDate)).format("LL")}
        </TableCell>
      </TableRow>
    );
  }
}

export default withStyles(useStyles)(withRouter(MyBooksBody));
